import React, { useRef } from "react";
import { motion } from "framer-motion";
import { FaArrowRight, FaChevronLeft, FaChevronRight } from "react-icons/fa";
import { Link } from "react-router-dom";

import cs1 from "../../images/news1.jpeg";
import cs2 from "../../images/news2.jpeg";
import cs3 from "../../images/news3.jpeg";
import cs4 from "../../images/news4.jpeg";
import cs5 from "../../images/news5.jpeg";
import cs6 from "../../images/news4.jpeg";
import cs7 from "../../images/blog13.png";
import cs8 from "../../images/blog15.png";
import cs9 from '../../images/blog9.png';
import cs10 from '../../images/blog10.png';
import cs11 from '../../images/blog11.png';
import cs12 from '../../images/blog12.png';

function SuggestedBlogs() {
    const scrollRef = useRef(null);

    const scroll = (direction) => {
        const container = scrollRef.current;
        const scrollAmount = container.offsetWidth; // scroll one full visible width

        if (direction === "left") {
            container.scrollBy({ left: -scrollAmount, behavior: "smooth" });
        } else {
            container.scrollBy({ left: scrollAmount, behavior: "smooth" });
        }
    };

    const features = [
        // {
        //     id: 1,
        //     image: cs1,
        //     alt: "Left",
        //     title: "Workflow Automation Software: Save Hours, Earn More",
        //     description: "How workflow automation software helps businesses save time, reduce manual effort, and boost productivity.",
        //     link: "/workflow-automation-software",
        //     animation: { initial: { opacity: 0, x: -50 }, animate: { opacity: 1, x: 0 }, delay: 0 }
        // },
        // {
        //     id: 2,
        //     image: cs2,
        //     alt: "Center",
        //     title: "Invoice Approval Software: The Smart Choice for Business",
        //     description: "Discover how invoice approval software simplifies financial workflows and improves approval efficiency.",
        //     link: "/invoice-approval-software",
        //     animation: { initial: { opacity: 0, y: 50 }, animate: { opacity: 1, y: 0 }, delay: 0.1 }
        // },
        // {
        //     id: 3,
        //     image: cs3,
        //     alt: "Right",
        //     title: "The Future of AI Product Development in E-Commerce Brands",
        //     description: "Exploring how AI-driven product development is reshaping the future of modern e-commerce brands.",
        //     link: "/the-future-of-ai-in-ecommerce",
        //     animation: { initial: { opacity: 0, x: 50 }, animate: { opacity: 1, x: 0 }, delay: 0.2 }
        // },
        // {
        //     id: 4,
        //     image: cs4,
        //     alt: "Left",
        //     title: "Algo Trading Software: A Game Changer for Modern-Day Traders",
        //     description: "Why algorithmic trading software is revolutionizing trading strategies for today’s traders.",
        //     link: "/algo-trading-software",
        //     animation: { initial: { opacity: 0, x: -50 }, animate: { opacity: 1, x: 0 }, delay: 0 }
        // },
        // {
        //     id: 5,
        //     image: cs5,
        //     alt: "Center",
        //     title: "How a Custom ERP Can Save Your Operations Team 20+ Hours a Week",
        //     description: "Discover how custom ERP solutions can streamline operations and save valuable time for your team.",
        //     link: "/custom-erp-solutions",
        //     animation: { initial: { opacity: 0, y: 50 }, animate: { opacity: 1, y: 0 }, delay: 0.1 }
        // },
        // {
        //     id: 6,
        //     image: cs6,
        //     alt: "Right",
        //     title: "Is Your User Data Actually Safe? 2026 Standards for Cybersecurity in SaaS",
        //     description: "How modern cybersecurity standards are protecting user data in SaaS applications.",
        //     link: "/cybersecurity-in-saas",
        //     animation: { initial: { opacity: 0, x: 50 }, animate: { opacity: 1, x: 0 }, delay: 0.2 }
        // },
        {
            id: 7,
            image: cs7,
            alt: "Left",
            title: "Peregrinee’s Complete Guide to Custom Web App Development",
            description: "An in-depth look at Peregrinee’s Complete Guide to Custom Web App Development streamline operations and maximize ROI.",
            link: "/custom-web-app-development-peregrinee",
            animation: { initial: { opacity: 0, x: -50 }, animate: { opacity: 1, x: 0 }, delay: 0 }
        },
        {
            id: 8,
            image: cs8,
            alt: "Center",
            title: "Web App Development Process at Peregrinee: From Idea to Launch",
            description: "Understanding how modern Web App Development Process at Peregrinee: From Idea to Launch",
            link: "/web-app-development-at-peregrinee",
            animation: { initial: { opacity: 0, y: 50 }, animate: { opacity: 1, y: 0 }, delay: 0.1 }
        },
        {
            id: 9,
            image: cs9,
            alt: "Center",
            title: "Why Businesses Choose Peregrinee for Custom Software Development",
            description: "Explore why growing businesses trust Peregrinee for scalable, secure, and fully customized software solutions tailored to their operational needs.",
            link: "/why-businesses-choose-peregrinee",
            animation: { initial: { opacity: 0, y: 50 }, animate: { opacity: 1, y: 0 }, delay: 0.1 }
        },
        {
            id: 10,
            image: cs10,
            alt: "Right",
            title: "How Peregrinee Delivers High-Performance Web Applications",
            description: "Discover how Peregrinee builds fast, scalable, and performance-optimized web applications using modern architecture and cutting-edge technologies.",
            link: "/high-performance-web-applications",
            animation: { initial: { opacity: 0, x: 50 }, animate: { opacity: 1, x: 0 }, delay: 0.2 }
        },
        {
            id: 11,
            image: cs11,
            alt: "Left",
            title: "Peregrinee’s Approach to MVP Development for Startups",
            description: "Learn how Peregrinee helps startups validate ideas faster with lean MVP development, rapid prototyping, and scalable architecture planning.",
            link: "/mvp-development-for-startups",
            animation: { initial: { opacity: 0, x: -50 }, animate: { opacity: 1, x: 0 }, delay: 0 }
        },
        {
            id: 12,
            image: cs12,
            alt: "Center",
            title: "Cost to Build a Web App in 2026 – Insights from Peregrinee",
            description: "Understand the real cost factors of web app development in 2026, including features, tech stack, scalability, and long-term maintenance considerations.",
            link: "/cost-to-build-web-app-2026",
            animation: { initial: { opacity: 0, y: 50 }, animate: { opacity: 1, y: 0 }, delay: 0.1 }
        },


    ];
    return (
        <section style={{ padding: "60px 0", background: "#fff", position: "relative" }}>

            {/* Heading */}
            <motion.section className="container mb-5"
                initial={{ y: 30, opacity: 0 }}
                whileInView={{ y: 0, opacity: 1 }}
                viewport={{ once: false, amount: 0.6 }}
                transition={{ duration: 0.8, ease: "easeOut" }}>
                <div className="d-flex align-items-center justify-content-center text-center flex-wrap">
                    <div className="px-3 fw-bold responsive-heading">Our <span className="highlight-orange">Other Blogs</span>
                    </div>
                </div>
                <div className="d-flex justify-content-center mt-3">
                    <span className="text-center fw-bold" style={{ fontSize: '22px', color: '#000', fontWeight: '500' }}>
                        Insights, trends, and expert perspectives on <span className="highlight-orange">technology</span>, <span className="highlight-orange">innovation</span>, and <span className="highlight-orange">digital transformation</span>.
                    </span>

                </div>
                {/* <div className="d-flex justify-content-center mt-4">
              <a
                  href="#contact-us"
                  className="btn custom-orange-btn py-3 px-4 fw-bold"
              >
                  Get in Touch With Us
              </a>
          </div> */}
            </motion.section>

            {/* Left Arrow */}
            <button
                onClick={() => scroll("left")}
                style={{
                    position: "absolute",
                    left: "10px",
                    top: "55%",
                    transform: "translateY(-50%)",
                    background: "#f57c00",
                    border: "none",
                    color: "#fff",
                    width: "40px",
                    height: "40px",
                    borderRadius: "50%",
                    cursor: "pointer",
                    zIndex: 10,
                }}
            >
                <FaChevronLeft />
            </button>

            {/* Right Arrow */}
            <button
                onClick={() => scroll("right")}
                style={{
                    position: "absolute",
                    right: "10px",
                    top: "55%",
                    transform: "translateY(-50%)",
                    background: "#f57c00",
                    border: "none",
                    color: "#fff",
                    width: "40px",
                    height: "40px",
                    borderRadius: "50%",
                    cursor: "pointer",
                    zIndex: 10,
                }}
            >
                <FaChevronRight />
            </button>

            {/* Scroll Container */}
            <div
                ref={scrollRef}
                style={{
                    display: "flex",
                    overflow: "hidden",
                    gap: "20px",
                    padding: "0 60px",
                }}
            >
                {features.map((feature) => (
                    <div
                        key={feature.id}
                        style={{
                            flex: "0 0 23%",
                            minWidth: "250px",
                        }}
                    >
                        <Link to={feature.link} style={{ textDecoration: "none" }}>
                            <motion.div
                                whileHover={{ scale: 1.03 }}
                                transition={{ duration: 0.3 }}
                                style={{
                                    background: "#fff",
                                    borderRadius: "12px",
                                    boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
                                    overflow: "hidden",
                                }}
                            >
                                <img
                                    src={feature.image}
                                    alt={feature.title}
                                    style={{ width: "100%", height: "200px", objectFit: "cover" }}
                                />

                                <div style={{ padding: "20px" }}>
                                    <h5 style={{ fontSize: "16px", fontWeight: "600", color: "#222" }}>
                                        {feature.title}
                                    </h5>
                                    <p style={{ fontSize: "14px", color: "#666", marginTop: "8px" }}>
                                        {feature.description}
                                    </p>

                                    <div style={{ marginTop: "15px", textAlign: "right" }}>
                                        <span
                                            style={{
                                                display: "inline-flex",
                                                alignItems: "center",
                                                gap: "6px",
                                                padding: "8px 14px",
                                                background: "#f57c00",
                                                color: "#fff",
                                                borderRadius: "30px",
                                                fontSize: "13px",
                                            }}
                                        >
                                            Read More <FaArrowRight size={12} />
                                        </span>
                                    </div>
                                </div>
                            </motion.div>
                        </Link>
                    </div>
                ))}
            </div>
        </section>
    );
}

export default SuggestedBlogs;